__turbopack_context__.v({
  "banner": "KCuota_banner",
  "comboResultFrame": "KCuota_comboResultFrame",
  "content": "KCuota_content",
  "draftStatus": "KCuota_draftStatus",
  "exampleStatus": "KCuota_exampleStatus",
  "footer": "KCuota_footer",
  "header": "KCuota_header",
  "okStatus": "KCuota_okStatus",
});
